import { SupportedFeaturesCollectionFunctions } from 'data/supportedFeatures/supportedFeatures.types';
import { FormTemplateMapByKey } from 'data/template/template.types';
import {
  CollectionFunctionInterface,
  CollectionFunctionListData
} from 'data/collectionFunction/collectionFunction.types';
import { ExportOption } from 'routes/AccessFunction/containers/AccessFunctionList/components/DialogBody/ExportReportDialogBody';

const exportCfsToFile = async (
  collectionFunctions: CollectionFunctionListData[],
  headers: string[],
  enabledCollectionFunctions: SupportedFeaturesCollectionFunctions,
  collectionFunctionTemplates: FormTemplateMapByKey,
  option: ExportOption,
  exportLimit: number
) => {
  const entities = collectionFunctions.slice(0, exportLimit).map((cf) => {
    return {
      name: cf.name,
      id: cf.decodedId,
      handoverProtocol: cf.tagName,
      lea: cf.cfGroup,
      behindNAT: cf.insideNat,
      hi2Interfaces: cf.hi2Interfaces ?? [],
      hi3Interfaces: cf.hi3Interfaces ?? []
    };
  });
  if (option.fileFormat === 'json') {
    exportToJsonFile(option, entities);
  }
};

function exportToJsonFile(
  option: ExportOption,
  entities: {
    name: string;
    id: string | undefined;
    handoverProtocol: string | undefined;
    lea: {
        id: string;
        name: string;
    } | undefined;
    behindNAT: boolean;
    hi2Interfaces: CollectionFunctionInterface[];
    hi3Interfaces: CollectionFunctionInterface[];
}[]
) {
  const json = JSON.stringify(entities, null, 2);
  const blob = new Blob([json], { type: 'application/json' });
  const url = URL.createObjectURL(blob);

  const a = document.createElement('a');
  a.href = url;
  a.download = option.filename.endsWith('.json')
    ? option.filename
    : `${option.filename}.json`;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}

export default exportCfsToFile;
